import React, { FC, useState } from 'react'
import NoAccessAvailable from '@/routes/Pages/ReservationDetail/access/NoAccessAvailable'
import { usePropertyKeys } from '@/hooks/use-property-keys'
import PropertyKeysTable from '@/routes/Pages/ReservationDetail/access/PropertyKeysTable'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core'
import { AccessConfirmationModal } from '@/routes/Pages/ReservationDetail/access/AccessConfirmationModal'

interface Props {
    readonly reservationId: string;
}

const useStyles = makeStyles(() => ({
    tableWrapper: {
        marginTop: '20px',
        display: 'grid',
        rowGap: '20px',
        justifyItems: 'start'
    }
}))

const AccessInfo: FC<Props> = ({ reservationId }) => {
    const classes = useStyles()
    const [isGeneratingKeys, setIsGeneratingKeys] = useState<boolean>(false)
    const [isConfirmationVisible, setIsConfirmationVisible] = useState<boolean>(false)

    const {
        displayablePropertyKeys,
        hasDisplayablePropertyKeys,
        loadReservationPropertyKeys,
        createReservationPropertyKeys,
        deleteReservationPropertyKeys,
        loadScheduledKeys,
    } = usePropertyKeys(reservationId)

    async function generatePropertyKeys(): Promise<void> {
        try {
            setIsGeneratingKeys(true);
            createReservationPropertyKeys();

            await new Promise((resolve) => setTimeout(resolve, 3000))

            loadReservationPropertyKeys();
            loadScheduledKeys();
        } finally {
            setIsGeneratingKeys(false);
        }
    }

    return (
        <div>
            <h2>
                Access
            </h2>

            { !hasDisplayablePropertyKeys && (
                <NoAccessAvailable
                    enableAccess={generatePropertyKeys}
                    isGeneratingKeys={isGeneratingKeys}
                />
            )}

            { hasDisplayablePropertyKeys && (
                <div className={classes.tableWrapper}>
                    <PropertyKeysTable propertyKeys={displayablePropertyKeys}/>

                    <Button
                        onClick={() => setIsConfirmationVisible(true)}
                        variant="outlined"
                        disabled={isGeneratingKeys}
                    >
                        Revoke access
                    </Button>

                    <AccessConfirmationModal
                        show={isConfirmationVisible}
                        onSubmit={deleteReservationPropertyKeys}
                        onClose={() => setIsConfirmationVisible(false)}
                    >
                        <>
                            <p>Are you sure you want to revoke this guest's access to the property?</p>
                            <br/>
                            <p>After revoking access, the guest will no longer see the access information in the Guest Area, and the door codes/remote opening will be deleted or cease to function.</p>
                        </>
                    </AccessConfirmationModal>
                </div>
            )}
        </div>
    )
}

export default AccessInfo
